<template>
  <v-combobox
    :id="id"
    ref="combo"
    :value="valueObject"
    @input="onInput($event)"
    :error-messages="errorMessages"
    :items="items"
    :item-text="documentsTypeItemText"
    :item-value="documentsTypeItemKey"
    :label="label"
    :loading="isDocumentsTypeBusy"
    :rules="rules"
    :readonly="readonly"
    :required="required"
  ></v-combobox>
</template>
<script>
import {
  documentTypeStoreData,
  documentTypeStoreActions
} from '../store/documentTypeStoreHelpers'

export default {
  name: 'DocumentTypeCombo',
  props: {
    value: {
      type: String
    },
    errorMessages: {
      type: Array
    },
    label: {
      type: String,
      default: 'Tipo de Documento'
    },
    readonly: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default() {
        return []
      }
    },
    id: {
      type: String
    },
    required: {
      type: Boolean,
      required: false
    }
  },
  created() {
    if (this.documentsType.length <= 0 && !this.isDocumentsTypeBusy) {
      this.getDocumentsType()
    }
  },
  computed: {
    ...documentTypeStoreData,
    items() {
      return this.documentsType.filter(d => {
        return d.activo && d.visible
      })
    },
    valueObject() {
      if (this.items.length > 0 && this.value != null) {
        const item = this.documentsType.find(element =>  element.idTipoDocumento == this.value)
        if (item != undefined) {
          return item
        }
      }
      return null
    }
  },
  methods: {
    ...documentTypeStoreActions,
    onInput(event) {
      let value = null
      if (typeof event === 'object') {
        value = event[this.documentsTypeItemKey]
      }
      this.$emit('input', value)
      this.$emit('change', value)
    },
    reset() {
      this.$refs.combo.reset()
    }
  }
}
</script>
